import { PAGE_ROUTES } from './permissionKeys';

export const resolvePageHeader = pathname => {
  const path = pathname.replace(/\/$/, '') || '/';
  if (path === '/settings' || path.startsWith('/settings/')) {
    return { key: 'settings', label: 'Global Settings', nav: false };
  }
  return PAGE_ROUTES.find(route => route.path === path || route.aliases?.includes(path))
    || [...PAGE_ROUTES].sort((a, b) => b.path.length - a.path.length)
      .find(route => path.startsWith(`${route.path}/`));
};
